import repository from '@/utils/repository';

const resource = '/move/MNG_AuthorApp002';

export default {
    getData: (data) => {
        return repository.post(`${resource}/getData`, {
            ...data
        });
    },
    storeSave: (data) => {
        if (data instanceof FormData) {
            return repository.post(`${resource}/storeSave`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
        return repository.post(`${resource}/storeSave`, { ...data });
    },
    storeCancel: (data) => {
        return repository.post(`${resource}/storeCancel`, { ...data });
    }
};
